// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"NN-z","carouselContainer":"ON-z"};